import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DashboardPerScopeValueRequest, DashboardPerScopeValueResponse } from '@api/domain/types';
import type { AppDispatch, RootState } from '@store/types';
import { backendCall, createApiCall } from '@reducers/utils';

interface FetchDashboardPerScopeValueWorstArgs {
  params: DashboardPerScopeValueRequest;
  signal?: AbortSignal;
}

export const fetchDashboardPerScopeValueWorst = createAsyncThunk<
  DashboardPerScopeValueResponse | undefined,
  FetchDashboardPerScopeValueWorstArgs,
  { state: RootState; dispatch: AppDispatch }
>('dashboard/fetchDashboardPerScopeValueWorst', async ({ params, signal }, { dispatch }) => {
  return await dispatch(
    backendCall(
      createApiCall((api) => api.dashboard.getDashboardPerScopeValue, {
        params,
        signal,
      })
    )
  );
});
